<template>

  <v-dialog
    v-model="show"
    persistent
    max-width="470">
    <v-card>
        <v-card-title>
             
          <p>PAYABLES: {{$money(payment.total_amount)}} </p>
      

        </v-card-title>
       
        <v-card-text>
            
             <v-form
                ref="form"
                v-model="valid"
                lazy-validation
              >
              <div v-if="type=='Cash'">
                <v-text-field
                dense
              
                  :value="$money(payment.amount)"
                  label="SALES AMOUNT"
                  :disabled="true"
                ></v-text-field>
               
                <v-text-field
                dense
                :value="$money(payment.service_charge)"
                  label="SERVICE CHARGE"
                   :disabled="true"
                ></v-text-field>
                <v-text-field
                dense
                 :disabled="true"
                 :value="$money(payment.trucking_fee)"
                  label="TRUCKING FEE"
                ></v-text-field>

              
              </div>


              <div v-if="type=='Credit'">
                <v-text-field
                v-model="pay_amount"
                label="Enter amount"
                type="number"
                @focus="pay_amount=''"
                :rules="textRules"
                        outlined
                ></v-text-field>
               
                <div>Amoun to pay: <strong>{{$money(pay_amount)}}</strong></div>
              </div>


             </v-form>
             <v-alert
                 v-if="!btn" 
                            dense
                            style="width: 100%"
                            class="mt-1"
                            text
                            type="info"
                            >
                            Payment already initiated! Please proceed to the cashier.
                            </v-alert>
        </v-card-text>
        <v-card-actions>
                <v-btn color="warning" large rounded text @click="emitToParent('close')">CLOSE</v-btn>
            <v-spacer></v-spacer>
            <v-btn v-if="btn"  large color="success" rounded depressed  @click="validate()">CONFIRM</v-btn>
        </v-card-actions>
    </v-card>

  </v-dialog>
</template>

<script>
import { API_MIXINS } from '@/mixins/api_mixins.js'
export default {
    mixins: [API_MIXINS],
  props: {
    show: {
        type: Boolean,
        default: false
    },
    payment: {
        type: Object,
        default: ()=>{ return {} }
    },
    sales: {
        type: Object,
        default: ()=>{ return {} }
    },
    customer: {
      type: Object,
        default: ()=>{ return {} }
    },
    sales_date: {
      type: String,
        default: ''
    },
    type: {
        type: String,
        default: 'Cash'
    }
  },
  data: () => ({
      valid: true,
      confirm: false,
      btn: false,
      pay_amount: "",
      _date: "",
      payments:[],
      textRules: [
        v => !!v || 'Field is required'
      ],
  }),
  computed: {
   
  },
  watch: {
    show(v) {
        if(v) {
          this._date  = "_" + this.$moment().format('YYYY-MM-DD')
          this.readRef()
        }
    }
  },
  methods: {
    validate () {
        if (this.$refs.form.validate()) {
           if(this.type == "Credit") {
              this.CreditPay()
           } else {
              this.CashPay()
           }
          
        }
      },
    emitToParent (action) {
      this.$emit('DialogEvent', action)
    },
    readRef() {
        this.btn = false
        let dbRef= this.$refdb(this.$FBDB);
        this.$getdb(this.$childdb(dbRef, 'payments/'+this._date +"/"+this.customer.email)).then((snapshot) => {
                  if (snapshot.exists()) {
                    this.btn = false
                    this.VA_ALERT('info', "Payment already initiated! Please proceed to the cashier.")
                  } else {
                    this.btn = true
                  }
                }).catch((error) => {
                  console.error(error);
                });

       },
       CashPay() {
        let custURL = this._date  +"/"+this.customer.email
        let action = "Customer " +  this.customer.firstname + " Initiate payment on " + this.$moment().format('YYYY-MM-DD hh:mm:ss a')
        var data = {"acct": this.customer.email,
                "amt": this.payment.total_amount,
                "logs": [
                  {
                    "action": action
                  }
                ],
                "sc": this.payment.service_charge,
                "status": "Initiated",
                "tf": this.payment.trucking_fee,
        }
        this.$setdb(this.$refdb(this.$FBDB, 'payments/' + custURL), data);
        this.btn = false
       }, 
       
       CreditPay() {
            let custURL = this._date +"/"+this.customer.email
            let action = "Customer " +  this.customer.firstname + " Initiate payment on " + this.$moment().format('YYYY-MM-DD hh:mm:ss a')
            var data = {"acct": this.customer.email,
                    "amt": this.pay_amount,
                    "logs": [
                      {
                        "action": action
                      }
                    ],
                    "status": "Initiated",
            }
            this.$setdb(this.$refdb(this.$FBDB, 'payments/' + custURL), data);
            this.btn = false
       }, 
    
  }
}
</script>
